import React from 'react';
import { translate } from '@utils/i18n';
import { Tag } from '@components/Tags';
const namespace = 'features.dashboards.inspection_assistant_insights';
const checkValueIsEmpty = (value) => {
    if (Array.isArray(value)) {
        return value.length === 0;
    }
    if (typeof value === 'string') {
        return value === '';
    }
    return value === 0;
};
function InsightCard({ isLoading, title, value, trend }) {
    return (React.createElement("div", { className: "insight-card" },
        React.createElement("span", { className: "title" }, title),
        isLoading && (React.createElement("div", { className: "load-spinner load-32" },
            React.createElement("svg", { role: "img" },
                React.createElement("use", { href: "/map.svg#load-spinner" })))),
        !isLoading && checkValueIsEmpty(value) && (React.createElement("em", { className: "value", style: { fontSize: '12px', color: '#666' } }, translate('no_results', { namespace }))),
        !isLoading && !Array.isArray(value) && !checkValueIsEmpty(value) && (React.createElement("div", { className: "value" },
            React.createElement("span", null, value),
            trend && trend.direction !== 'neutral' && (React.createElement("i", { className: `fa-light fa-arrow-${trend.direction === 'up' ? 'up' : 'down'}`, title: `${trend.direction === 'down'
                    ? translate('decreased', { namespace })
                    : translate('increased', { namespace })} by ${trend.percentage}%` })))),
        !isLoading && Array.isArray(value) && !checkValueIsEmpty(value) && (React.createElement("div", { className: "tag-values" }, value.map((item) => (React.createElement(Tag, { key: item.name, value: item.name, attributeName: item.name, variant: item.variant, readOnlyMode: true })))))));
}
export default InsightCard;
